import { BatchState, TCardCampBatch } from '@/types/camp/CardCamp';
import {
  requestDelete,
  requestGet,
  requestPost,
  requestPut,
  requestPutJson,
} from '@/utils/request';
import { TFinishRule } from '@/types/camp/campIndex/indexTypes';

export interface TCardCampBasicForm {
  name: string;
  product: string;
  ownerId?: number;
  ownerNameEn: string;
  ownerName?: string;
  administrators?: string;
  cover: string;
  info?: string;
}

export interface TSortItem {
  id: string;
  index: number;
}

export interface TCardCampSortForm {
  items?: Array<TSortItem>;
}

export interface BatchInfoType {
  beforeStartNum: number;
  startNum: number;
  endNum: number;
}

export interface TCardCampVO {
  isHaveNode: boolean;
  id: string;
  name: string;
  product: string;
  ownerId: number;
  ownerName: string;
  visible: number;
  recommendable: number;
  administrators?: string;
  cover: string;
  info?: string;
  recruitPage?: object;
  finishRule?: object;
  index?: number;
  batchInfo?: BatchInfoType;
}
/**
 * 复制打卡营
 * */
export const copyCamp = async (id: string, data: TCardCampBasicForm) => {
  return requestPost(`/v2/camp/api/card/camp/copy/${id}`, data);
};
export const create = async (data: TCardCampBasicForm) => {
  return requestPost(`/v2/camp/api/card/camp`, data);
};

export const editCamp = async (id: string, data: TCardCampBasicForm) => {
  return requestPut(`/v2/camp/api/card/camp/${id}`, data);
};

export const recruitPage = async (id: string, data: {}) => {
  return requestPutJson(`/v2/camp/api/card/camp/${id}/recruit/page`, data);
};

/**
 * 修改结营规则配置
 * @param id
 * @param data
 * @returns
 */
export const updateFinishRule = async (id: string, data: TFinishRule) => {
  return requestPut(`/v2/camp/api/card/camp/${id}/finish/rule`, data);
};

export const modifyVisible = async (id: string, visible: number) => {
  const formData = new FormData();
  formData.append('visible', visible === 1 ? '1' : '0');
  return requestPut(`/v2/camp/api/card/camp/${id}/visible`, formData);
};

export const modifyRecommendable = async (id: string, recommendable: number) => {
  const formData = new FormData();
  formData.append('recommendable', recommendable === 1 ? '1' : '0');
  return requestPut(`/v2/camp/api/card/camp/${id}/recommendable`, formData);
};

export const deleteCardCamp = async (id: string) => {
  return requestDelete(`/v2/camp/api/card/camp/${id}`, {});
};

export const info = async (id: string) => {
  return requestGet(`/v2/camp/api/card/camp/${id}`, {});
};

export const listAll = async () => {
  return requestGet(`/v2/camp/api/card/camp/list`, {});
};

export const sortCamp = async (data: TCardCampSortForm) => {
  return requestPut(`/v2/camp/api/card/camp/sort`, data);
};

/**
 * 分页查找批次
 * @param query
 */
export const pageCardCampBatch = async (query: {
  current: number;
  size: number;
  cardCampId: string;
  name?: string;
  states?: BatchState[];
}) => {
  return requestPost(`/v2/camp/api/card/camp/batch/page`, query);
};

export const removeCardCampBatch = async (id: string) => {
  return requestDelete(`/v2/camp/api/card/camp/batch/${id}`, {});
};

export const createCardCampBatch = async (data: TCardCampBatch) => {
  return requestPost(`/v2/camp/api/card/camp/batch`, data);
};

export const updateCardCampBatch = async (data: TCardCampBatch) => {
  return requestPut(`/v2/camp/api/card/camp/batch/${data.id}`, data);
};

export const getCardCampBatch = async (id: string) => {
  return requestGet(`/v2/camp/api/card/camp/batch/${id}`, {});
};

export const checkCardCampBatchStTimeExists = async (
  cardCampId: string,
  stTime: Date,
  batchId?: string,
) => {
  return requestGet(`/v2/camp/api/card/camp/batch/check/repeat`, {
    batchId,
    cardCampId,
    stTime: stTime.toISOString(),
  });
};
